import { Injectable } from '@angular/core';
import { CanLoad, Route, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { RoleType } from 'src/app/nio-common/models';
import { SharedSessionService } from 'src/app/nio-common/services/shared-session.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanLoad {
  constructor(
    private readonly router: Router,
    private readonly sharedSessionService: SharedSessionService,
  ) {}

  canLoad(
    route: Route,
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (!route.data || !Object.prototype.hasOwnProperty.call(route.data, 'needAuth')) return false;

    if (!!this.sharedSessionService.userInfo === route.data.needAuth) return true;
    if (
      this.sharedSessionService.userInfo &&
      this.sharedSessionService.userRole === RoleType.ADMIN
    ) {
      this.router.navigate(['/admin/events']);
    } else {
      this.router.navigate(['/events']);
    }
    return false;
  }
}
